"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Sidebar/CampaignsList/DraftPlaceholderItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _team = require('shared/selectors/team');
var _hooks = require('web/services/hooks');
var _Avatar = require('web/components/Avatar');
var _defaultTeam = require('../../defaultTeam');
var _TeamBadge = require('./TeamBadge'); var _TeamBadge2 = _interopRequireDefault(_TeamBadge);

const PLACEHOLDER_KEY = 'new' 

/* M12: while the wizard's Details step is open, the campaign it will create
 * shows at the top of the list. Nothing is saved until Continue. */
const DraftPlaceholderItem = () => {
  // Rev 29 Y1: the team Details preselects, so the row is as tall as a saved one.
  const teamName = _hooks.useAppSelector.call(void 0, state => {
    const teamKey = _defaultTeam.selectDefaultCampaignTeamKey.call(void 0, state)
    return teamKey ? _nullishCoalesce(_optionalChain([_team.selectTeamByKey.call(void 0, state, teamKey), 'optionalAccess', _ => _.Name]), () => ( '')) : ''
  })
  return (
    _react2.default.createElement('div', {
      className: "broadcast-list--campaign broadcast-list--campaign--viewed" ,
      'aria-current': "page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}

      , _react2.default.createElement('div', { className: "broadcast-list--campaign--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
        , _react2.default.createElement(_Avatar.CampaignAvatar, {
          size: 44,
          campaignKey: PLACEHOLDER_KEY,
          className: "broadcast-list--campaign-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
        )
        , _react2.default.createElement('div', { className: "broadcast-list--campaign-info broadcast-list--campaign-info--draft" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
          , _react2.default.createElement('span', { className: "broadcast-list--campaign-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "New campaign" )
          , _react2.default.createElement('span', { className: "campaign-status campaign-status--inactive broadcast-list--campaign-desc"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}, "Draft · not yet sent"

          )
          , _react2.default.createElement(_TeamBadge2.default, { name: teamName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
        )
      )
    )
  )
}

exports. default = DraftPlaceholderItem
